export const reportSelector = (state) => state.report.report.data;
export const fieldMappingSelector = (state) => state.report.fieldMapping.data;
